import React from 'react';
import { Spinner } from 'react-bootstrap';
import './backdrop.scss';

const BackDropReconnecting = ({ show ,message}) => (
  <div className={`backdropReconnecting ${show ? 'show' : ''}`}>
   <span style={{display:'flex',justifyContent:'center',alignItems:'center',flexDirection:'column'}}>
   <div class="custom-loader"></div>
   <span className='fs-5 mt-1 text-center'>{message}</span>
   </span>

   
    
  </div>
);

export default BackDropReconnecting;